import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M2 4.66667C2 4.29848 2.29848 4 2.66667 4H13.3333C13.7015 4 14 4.29848 14 4.66667C14 5.03486 13.7015 5.33333 13.3333 5.33333H2.66667C2.29848 5.33333 2 5.03486 2 4.66667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M3.33333 8C3.33333 7.63181 3.63181 7.33333 4 7.33333H12C12.3682 7.33333 12.6667 7.63181 12.6667 8C12.6667 8.36819 12.3682 8.66667 12 8.66667H4C3.63181 8.66667 3.33333 8.36819 3.33333 8Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M5.33333 10.6667C4.96514 10.6667 4.66667 10.9651 4.66667 11.3333C4.66667 11.7015 4.96514 12 5.33333 12H10.6667C11.0349 12 11.3333 11.7015 11.3333 11.3333C11.3333 10.9651 11.0349 10.6667 10.6667 10.6667H5.33333Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}